import Swiper from 'swiper/js/swiper.js';
import Flickity from "flickity";
import simpleParallax from 'simple-parallax-js';

class Bulider{
    constructor() {
        this.zigzag = document.querySelector('.zigzag') ? document.querySelectorAll('.zigzag') : null;
        this.flickity_icons = document.querySelector('.flickity_icons') ? document.querySelectorAll('.flickity_icons') : null;
        this.slide_image_link = document.querySelector('.slide_image_link') ? document.querySelectorAll('.slide_image_link') : null;
        this.section_events = document.querySelector('.section_events') ? document.querySelectorAll('.section_events') : null;
        this.video = document.querySelector('.paralax__video') ? document.querySelectorAll('.paralax__video') : null;
        this.section_info_buttons = document.querySelector('.section_info_buttons') ? document.querySelectorAll('.section_info_buttons') : null;
        
        !this.section_events || this.section_events.forEach(el => this.eventHeight(el));
        !this.slide_image_link || this.slide_image_link.forEach(el => this.slideImage(el));
        !this.zigzag || this.zigzag.forEach(el => this.slideZigzag(el));
        !this.flickity_icons || this.flickity_icons.forEach(el => this.slideFlickity(el));
        !this.video || this.video.forEach(el => new simpleParallax(el.querySelector('video')));
        //!this.section_info_buttons || this.section_info_buttons.forEach(el => this.hoverItem(el));
        ['scroll', 'DOMContentLoaded'].forEach(ev => document.addEventListener(ev  , () => {
            if (this.section_info_buttons) this.section_info_buttons.forEach(el => this.scrollItem(el));
        }))
    }

    hoverItem(el){
        el.querySelector('.left').addEventListener('mouseenter', e => {
            el.querySelector('.section_info_buttons__info').classList.add('active');
        });
        el.querySelector('.left').addEventListener('mouseleave', e => {
            el.querySelector('.section_info_buttons__info').classList.remove('active');
        })
    }

    scrollItem(el){
        let scrollableElement = el,
            element_position = scrollableElement.offsetTop,
            current_position = document.documentElement.scrollTop || document.body.scrollTop;
        if ((element_position - window.innerHeight + parseFloat(((scrollableElement.querySelector('.section_info_buttons__bc').offsetHeight * 2) - 10))) < current_position){
            el.classList.add('active');
        }else{
            el.classList.remove('active');
        }
      
    }

    eventHeight(el){
        setTimeout(() => {
            let height = 0;
            el.querySelectorAll('.box').forEach(item => {
                if (height <= item.querySelector('.box__info').offsetHeight){
                    height = item.querySelector('.box__info').offsetHeight;
                }
            })
            el.querySelectorAll('.box').forEach(el => el.querySelector('.box__info').style.height = height + 'px');
        }, 20);
    }

    slideImage(el){
        new Swiper(el.querySelector(".mySwiper"), {
            slidesPerView: 1.5,
            spaceBetween: 18,
            breakpoints: {
                768: {
                    slidesPerView: 2.9,
                    spaceBetween: 18,
                },
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            
        });
    }

    slideFlickity(el){
        if (window.innerWidth > 991){
            let flkty = new Flickity(el.querySelector('.main-carousel'), {
                groupCells: 1,
                freeScroll: true,
                wrapAround: true,
                initialIndex: 3,
                pageDots: false
    
    
            });
            var slides = el.querySelectorAll('.main-carousel .carousel-cell');
    
            slides.forEach(function (slide, index) {
                slide.addEventListener('click', function () {
                    // Aktywujemy kliknięty slajd
                    flkty.select(index);
                });
            });
        }

    }
 
    slideZigzag(el){
        new Swiper(el.querySelector('.swiper-container'), {
            loop: true,
            // If we need pagination
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            }
        });
    }
}




export default Bulider;